// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";

function MakeStore(funarg) {
  var state = {
    contents: funarg.initialState
  };
  var getState = function (param) {
    return state.contents;
  };
  var listeners = {
    contents: /* [] */0
  };
  var notifyListeners = function (oldState, newState) {
    Belt_List.forEach(listeners.contents, (function (param) {
            var cc = param[1];
            var f = cc.compare;
            if (f !== undefined && !Curry._2(f, oldState, newState)) {
              return ;
            } else {
              return Curry._1(cc.callback, newState);
            }
          }));
  };
  var asyncUpdate = function (cb) {
    var oldState = state.contents;
    state.contents = Curry._1(cb, state.contents);
    notifyListeners(oldState, state.contents);
  };
  var update = function (newState) {
    var oldState = state.contents;
    state.contents = newState;
    notifyListeners(oldState, state.contents);
  };
  var updateAndReturn = function (newState) {
    update(newState);
    return newState;
  };
  var updateWithSideEffects = function (newState, cb) {
    update(newState);
    return Curry._1(cb, newState);
  };
  var register = function (name, cb) {
    listeners.contents = Belt_List.setAssoc(listeners.contents, name, {
          compare: undefined,
          callback: cb
        }, (function (prim0, prim1) {
            return prim0 === prim1;
          }));
    Curry._1(cb, state.contents);
  };
  var unregister = function (name) {
    listeners.contents = Belt_List.removeAssoc(listeners.contents, name, (function (prim0, prim1) {
            return prim0 === prim1;
          }));
  };
  return {
          getState: getState,
          update: update,
          asyncUpdate: asyncUpdate,
          updateAndReturn: updateAndReturn,
          updateWithSideEffects: updateWithSideEffects,
          register: register,
          unregister: unregister
        };
}

export {
  MakeStore ,
}
/* No side effect */
